module.exports = __webpack_public_path__ + "static/media/fire.0fab9b79.mp3";